const InputError = (props) => {
    // role="alert" (implicit aria-live="assertive") so screen readers announce
    // validation errors the moment they appear. An optional id lets the
    // associated field point at it via aria-describedby. (WCAG 2.2 SC 3.3.1)
    return (
        <div className="input-error" id={props.id} role="alert">
            {props.children}
        </div>
    );
};

export default InputError;
